module.exports = __webpack_public_path__ + "img/heavyTransport.png";